/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi__filters__search_range = /** @type {(inputs: {}) => string} */ () => {
	return `Suchbereich`
};

const en_zoi__filters__search_range = /** @type {(inputs: {}) => string} */ () => {
	return `Search scope`
};

const es_zoi__filters__search_range = /** @type {(inputs: {}) => string} */ () => {
	return `Alcance de la búsqueda`
};

const fr_zoi__filters__search_range = /** @type {(inputs: {}) => string} */ () => {
	return `Périmètre de recherche`
};

const it_zoi__filters__search_range = /** @type {(inputs: {}) => string} */ () => {
	return `Ambito di ricerca`
};

const nl_zoi__filters__search_range = /** @type {(inputs: {}) => string} */ () => {
	return `Zoekbereik`
};

const pt_zoi__filters__search_range = /** @type {(inputs: {}) => string} */ () => {
	return `Âmbito de pesquisa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi__filters__search_range(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi__filters__search_range", locale)
	if (locale === "de") return de_zoi__filters__search_range(inputs)
	if (locale === "en") return en_zoi__filters__search_range(inputs)
	if (locale === "es") return es_zoi__filters__search_range(inputs)
	if (locale === "fr") return fr_zoi__filters__search_range(inputs)
	if (locale === "it") return it_zoi__filters__search_range(inputs)
	if (locale === "nl") return nl_zoi__filters__search_range(inputs)
	return pt_zoi__filters__search_range(inputs)
};